/**
 * 备案信息配置：根据访问域名显示对应的 ICP 备案号 / 公安备案号
 *
 * 使用说明：
 * 1. key 一律使用不带 www 的裸域名（小写）。匹配时会自动去掉 www 并转小写，所以
 *    www.mingqicaiwu.com 和 mingqicaiwu.com 都能命中 'mingqicaiwu.com' 这一项。
 * 2. 每个域名需在管局完成各自的网站备案后，把号码填到对应条目里。
 * 3. 未匹配到的域名回退到 DEFAULT_BEIAN。
 */
const BEIAN_MAP = {
  'mingqicaiwu.com': {
    icp: '京ICP备17073936号',
    gonganCode: '11010202011134'
  },
  // TODO: 其他域名备案通过后按下面格式补充即可，无需改动其他代码：
  'bjmqkj.com': {
    icp: '京ICP备17073936号-1',
    gonganCode: '11010202011135'
  }
}

/** 兜底配置：域名未匹配到时使用（与主域名保持一致） */
const DEFAULT_BEIAN = {
  icp: '京ICP备17073936号',
  gonganCode: '11010202011134'
}

/** 公安备案查询链接模板 */
const GONGAN_URL_TEMPLATE = 'https://beian.mps.gov.cn/#/query/webSearch?code='

function normalizeHost (hostname) {
  return String(hostname || '')
    .toLowerCase()
    .replace(/^www\./, '')
}

/**
 * 根据主机名获取备案展示信息
 * @param {string} [hostname] 不传时取 window.location.hostname（便于单测传入）
 * @returns {{icp: string, gonganName: string, gonganUrl: string}}
 */
export function getBeianByHost (hostname) {
  console.log(hostname);
  
  const host = normalizeHost(
    typeof hostname === 'string' ? hostname : window.location.hostname
  )
  const entry = BEIAN_MAP[host] || DEFAULT_BEIAN
  return {
    icp: entry.icp,
    gonganName: '京公网安备' + entry.gonganCode + '号',
    gonganUrl: GONGAN_URL_TEMPLATE + entry.gonganCode
  }
}



// WEBPACK FOOTER //
// ./src/config/beian.js